import { DraggableModal, DraggableModalProvider } from 'ant-design-draggable-modal';
import 'antd/dist/antd.css';
import 'ant-design-draggable-modal/dist/index.css';
import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { Spin, notification } from 'antd';
import './modal.less';

type ModalProps = {
  visible: boolean;
  handler: () => void;
  value: string;
  isLoading: boolean;
  width: number;
  height: number;
};

const Modal = (props: ModalProps): JSX.Element => {
  const {
    visible,
    handler,
    value,
    isLoading,
    width,
    height,
  } = props;
  const copyHandler = () => {
    navigator.clipboard.writeText(value);
    notification.success({
      message: 'Copied!',
    });
  };
  const getSpinnerPadding = () => `${height / 2}px`;
  return (
    <DraggableModalProvider>
      <DraggableModal
        initialHeight={height}
        initialWidth={width}
        open={visible}
        onOk={handler}
        onCancel={copyHandler}
        cancelText="Copy"
        okText="Close"
        closeIcon={<CopyOutlined />}
        cancelButtonProps={
          {
            disabled: isLoading,
            icon: <CopyOutlined />,
          }
        }
      >
        <Spin style={{ paddingTop: getSpinnerPadding() }} spinning={isLoading} size="large">
          <div className="wrapper">
            <pre>
              {value}
            </pre>
          </div>
        </Spin>
      </DraggableModal>
    </DraggableModalProvider>
  );
};
export default Modal;
